import type { AlCategory, AlStatus } from '@elva/ui';
import { useCallback, useState } from 'react';
import { AsyncBoundary } from '@/components/feedback';
import { AutopilotLogView, GrowthDashboardTopBarActions } from '@elva/ui';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useAutopilotLog, useAutopilotLogMutations } from '../hooks/useAutopilotLog';
import { autopilotCategoryToBe, autopilotStatusToBe } from '../api';

export function AutopilotLogPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const [activeCategory, setActiveCategory] = useState<AlCategory | 'all'>('all');
  const [activeStatus, setActiveStatus] = useState<AlStatus | 'all'>('all');

  const categoryFilter = autopilotCategoryToBe(activeCategory);
  const statusFilter = autopilotStatusToBe(activeStatus);
  const filters = {
    page: 1,
    limit: 100,
    days: 7,
    ...(categoryFilter ? { category: categoryFilter } : {}),
    ...(statusFilter ? { status: statusFilter } : {}),
  };

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useAutopilotLog(filters);
  const { exportCsv } = useAutopilotLogMutations();

  const handleExport = useCallback(() => {
    exportCsv.mutate();
  }, [exportCsv]);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <AutopilotLogView
        {...viewProps({
          simpleTimeline: data?.simpleTimeline,
          advancedActions: data?.advancedActions,
          totalActions: data?.totalActions,
          categoryCounts: data?.categoryCounts,
          activeCategory,
          onCategoryChange: setActiveCategory,
          activeStatus,
          onStatusChange: setActiveStatus,
          loading: isFetching || exportCsv.isPending,
          onExportCsv: handleExport,
          exportPending: exportCsv.isPending,
        })}
      />
    </AsyncBoundary>
  );
}
